(function () {
  'use strict';

  function priceToFloat(cents) {
    if (typeof cents !== 'number') return 0;
    return Math.round(cents) / 100;
  }

  function getItemFromCart(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return null;
    if (variantId != null) {
      const match = cart.items.find(function (i) {
        return String(i.variant_id) === String(variantId) || String(i.id) === String(variantId);
      });
      if (match) return match;
    }
    return cart.items[cart.items.length - 1] || null;
  }

  function trackAddToCart(opts) {
    opts = opts || {};
    const cart = opts.cart || {};
    const variantId = opts.variantId;
    const quantity = opts.quantity || 1;
    const item = getItemFromCart(cart, variantId);

    if (!item) return;

    const currency = (cart.currency || 'SEK').toUpperCase();
    const price = priceToFloat(item.final_price != null ? item.final_price : item.price);
    const value = price * quantity;
    const contentId = String(item.variant_id || item.id || variantId || '');
    const sku = item.sku || '';
    const title = item.product_title || item.title || '';

    // GA4 only — no fbq here. The Meta pixel app (Pixee) is the single
    // browser-side source for Meta commerce events. A second fbq('track')
    // from the theme cannot share Pixee's eventID, so Meta counts both.

    window.dataLayer = window.dataLayer || [];
    try {
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: currency,
          value: value,
          items: [{
            item_id: contentId,
            item_name: title,
            item_variant: item.variant_title || '',
            item_sku: sku,
            price: price,
            quantity: quantity
          }]
        }
      });
    } catch (e) {}
  }

  // Fires when the user is about to leave for /checkout — e.g. the A/B test
  // variant where subscription ATC skips the cart drawer. GA4 only
  // (begin_checkout): the Meta pixel app covers InitiateCheckout on its own,
  // and a theme-side fbq copy cannot be deduplicated against it (no shared
  // eventID), so it double-counts.
  function trackBeginCheckout(opts) {
    opts = opts || {};
    const cart = opts.cart || {};
    const source = opts.source || 'unknown';

    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

    const currency = (cart.currency || 'SEK').toUpperCase();
    const value = priceToFloat(cart.total_price);

    window.dataLayer = window.dataLayer || [];
    try {
      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: currency,
          value: value,
          items: cart.items.map(function (i) {
            return {
              item_id: String(i.variant_id || i.id),
              item_name: i.product_title || i.title || '',
              item_variant: i.variant_title || '',
              item_sku: i.sku || '',
              price: priceToFloat(i.final_price != null ? i.final_price : i.price),
              quantity: i.quantity || 1
            };
          })
        },
        moby_source: source
      });
    } catch (e) {}
  }

  window.MobyTracking = window.MobyTracking || {};
  window.MobyTracking.addToCart = trackAddToCart;
  window.MobyTracking.beginCheckout = trackBeginCheckout;
})();
